import styles from './TableContainer.module.scss'

export const presets = {
  primary: styles.container,
  clean: styles.clean
}
